// extracted by mini-css-extract-plugin
export default {"breakWord":"textEllipsis_breakWord__+oH5d","tooltip":"textEllipsis_tooltip__jmz9B","tooltipLeft":"textEllipsis_tooltipLeft__s3UhR","tooltipRight":"textEllipsis_tooltipRight__zyhax"};